module.exports = __webpack_public_path__ + "img/user-default.a4d644ce.svg";